import reduce from 'lodash/reduce';
import uniqueId from 'lodash/uniqueId';

import { IArticle } from '@r1-frontend/api-domru/content-static/dto/ResponseDto';

import { TArticle } from '~/src/features/internetV2/store/reducer';

export const articlesFormatter = (articles: IArticle[]) => {
    return reduce<IArticle, Record<string, TArticle>>(articles, (result, article) => {
        const key = uniqueId();

        result[key] = {
            question: article.articleQuestion,
            answer: article.articleAnswer,
            isOpen: false,
            key,
            id: +key,
        };

        return result;
    }, {});
};

